import { Navigate, Outlet } from 'react-router-dom';

// Route guard: restricts a route group to specific roles. Complements
// PrivateRoute (is the user authenticated?) and FeatureGuard (is the feature
// in the doctor's plan?) — this one enforces WHO may open a page at all.
// The sidebar only hides links per role; without this guard any authenticated
// user could deep-link into another role's pages (e.g. a patient opening
// #/adminDashboard). The backend still enforces data access — this closes the
// UI hole so foreign pages don't render/probe admin endpoints at all.
// Unauthorized users bounce to "/" which renders their own role's dashboard.
export default function RoleRoute({ allow = [] }) {
  const role = (localStorage.getItem('Role') || '').toLowerCase();

  if (!allow.includes(role)) {
    return <Navigate to="/" replace data-testid="role-route-redirect" />;
  }

  return <Outlet />;
}
